import React, { forwardRef } from 'react'
import ReactSelect, { GroupBase, Props, SelectInstance } from 'react-select'
import Creatable, { CreatableProps } from 'react-select/creatable'

const commonProps = {
  theme: (theme) => ({
    ...theme,
    borderRadius: 6,
    colors: {
      ...theme.colors,
      primary: 'var(--accent)',
      primary25: 'var(--green-50)',
      primary50: 'var(--green-100)',
      primary75: 'var(--green-200)',
      danger: 'var(--invalid-color)',
    },
  }),
  styles: {
    multiValue: (style) => ({
      ...style,
      backgroundColor: '#EAF0D5',
      borderRadius: 6,
      paddingInline: 6,
    }),
    multiValueRemove: (style) => ({
      ...style,
      ':hover': {
        backgroundColor: 'transparent',
        opacity: 0.6,
      },
    }),
  },
}

export function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group>) {
  return (
    <ReactSelect
      {...props}
      theme={commonProps.theme}
      styles={{
        ...commonProps.styles,
        ...props.styles,
      }}
    />
  )
}

// TODO Improve typescript support
export const SelectRef: any = forwardRef<any, Props>((props: Props, ref) => (
  <ReactSelect
    ref={ref}
    {...props}
    theme={commonProps.theme}
    styles={{
      ...commonProps.styles,
      ...props.styles,
    }}
  />
))

Select.displayName = 'Select'

export const CreatableSelect: any = forwardRef(
  <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
    props: CreatableProps<Option, IsMulti, Group>,
    ref,
  ) => (
    <Creatable
      ref={ref}
      {...props}
      theme={commonProps.theme}
      styles={{
        ...commonProps.styles,
        ...props.styles,
      }}
    />
  ),
)

CreatableSelect.displayName = 'CreatableSelect'
